import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJobCity, deleteJobCity, fetchJobCityList, updateJobCity } from "./JobCityListAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobCityListAsync = createAsyncThunk(
  "JobCityList/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchJobCityList();

      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deleteJobCityListAsync = createAsyncThunk(
  'JobCityList/delete',
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteJobCity(uuid);
      return uuid; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateJobCityListAsync = createAsyncThunk(
  'JobCityList/update',
  async ({ uuid, cityData }, { rejectWithValue }) => {
    try {
      const response = await updateJobCity(uuid, cityData);
    //   console.log("Response Slice", response)
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addJobCityListAsync = createAsyncThunk(
  "JobCityList/add",
  async (newCity) => {
    try {
      const data = await addJobCity(newCity);
    //   console.log("data in slice", data)
      return data;
    } catch (error) {
      console.log("errorL :" , error)
      // return rejectWithValue(error.message);
    }
  }
);

const JobCitySlice = createSlice({
  name: "JobCity",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobCityListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobCityListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchJobCityListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
      .addCase(addJobCityListAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addJobCityListAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateJobCityListAsync.pending, (state) => {
        state.loading = true;
        // console.log("Loading")
        state.error = null;
      })
      .addCase(updateJobCityListAsync.fulfilled, (state, action) => {
        state.loading = false;
        // console.log("data", state.data)
        state.data = state.data.map((cityData) =>
            cityData.uuid === action.payload.uuid ? action.payload : cityData
        );
      })
      .addCase(updateJobCityListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteJobCityListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteJobCityListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(
          (cityData) => cityData.uuid !== action.payload
        );
      })
      .addCase(deleteJobCityListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});
export const selectJobCity = (state) => state.jobCity.data;

export default JobCitySlice.reducer;
